__turbopack_context__.v({
  "root": "_2gM-gG_root",
  "tableTh___1C0Ga": "_2gM-gG_tableTh___1C0Ga",
  "tableTh__cg9Dj": "_2gM-gG_tableTh__cg9Dj",
  "tableTh__f7Joj": "_2gM-gG_tableTh__f7Joj",
  "tableTh__v3Lz": "_2gM-gG_tableTh__v3Lz",
  "tableTr__ni9TZ": "_2gM-gG_tableTr__ni9TZ",
});
